import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import postInsertReschedule from 'Api/reschedule/postInsertReschedule';
import { useToast } from 'Store/toast';
import { useModal } from 'Store/modal';
import { useLoader } from 'Store/loader';

import postInsertReschedulePayload from './model/request/postInsertReschedulePayload';

const usePostInsertReschedule = () => {
  const { t } = useTranslation('host-reschedule');
  const { onResetModal } = useModal();
  const queryClient = useQueryClient();
  const { id } = useParams();
  const navigate = useNavigate();
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();

  return useMutation({
    mutationKey: ['post-insert-reschedule', id],
    mutationFn: async (payload) => {
      onResetModal();

      onShowLoader({ variant: 'loader-primary' });

      const formData = postInsertReschedulePayload(payload);

      const response = await postInsertReschedule(id, formData);

      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['host-schedule-detail', id] });
      onOpenToast({
        status: 'success',
        description: t('success_submit'),
        duration: 5,
        alwaysShow: false,
      });
      navigate(`/host/detail/${id}`);
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.errors ? error?.response?.data?.errors[0]?.message : error?.response?.data?.message;

      onOpenToast({
        status: 'error',
        description: errorMessage,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => onResetLoader(),
  });
};

export default usePostInsertReschedule;
